import { useMemo } from 'react';

import { useGetProductCategoriesQuery } from '@/api/hooks/queries/use-get-product-categories-query';
import { categoryIdsToLabels } from '@/lib/products';

import { useSessionStore } from './use-session-store/use-session-store';

/**
 * Returns labels for the selected product categories, or an empty array when
 * nothing is selected or category data has not loaded yet.
 */
export function useEffectiveCategoryLabels(): string[] {
  const selectedCategoryIds = useSessionStore((s) => s.selectedCategoryIds);
  const { data: productCategories } = useGetProductCategoriesQuery();

  return useMemo(
    () => categoryIdsToLabels(selectedCategoryIds, productCategories),
    [selectedCategoryIds, productCategories]
  );
}
